import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import type RouterService from '@ember/routing/router-service';
import type StoreService from 'scaleflow/services/store';
import type FeatureAccessService from 'scaleflow/services/feature-access';

class BacklogIdeasRoute extends Route {
  @service declare store: StoreService;
  @service declare router: RouterService;
  @service declare betaToggle: any;
  @service('feature-access') declare featureAccessService: FeatureAccessService;

  beforeModel() {
    if (this.betaToggle.showIdeas !== true) {
      if (this.featureAccessService.canAccessFeature('/initiatives')) {
        this.router.replaceWith('backlog.initiatives');
      }
    }
    return Promise.all([
      this.store.findAll('department'),
      this.store.findAll('area'),
      this.store.findAll('theme'),
      this.store.findAll('customer'),
      this.store.findAll('person'),
      this.store.findAll('initiative'),
      this.store.findAll('group'),
    ]);
  }
}

export default instrumentRoutePerformance(BacklogIdeasRoute);
